
import React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface AccountsTableHeaderProps {
  onManualRefresh: () => void;
}

const AccountsTableHeader = ({ onManualRefresh }: AccountsTableHeaderProps) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>External ID</TableHead>
        <TableHead>Exchange</TableHead>
        <TableHead>Lead Account</TableHead>
        <TableHead>Strategy</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Primary</TableHead>
        <TableHead>
          <div className="flex items-center space-x-1">
            <span>Follow Links</span>
            <Badge 
              variant="outline" 
              className="ml-1 cursor-pointer hover:bg-muted" 
              onClick={onManualRefresh}
            >
              ↻
            </Badge>
          </div>
        </TableHead>
        <TableHead className="text-right">Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default AccountsTableHeader;
